var agnotis = agnotis || {};

$(document).ready(function () {
    $('#loading').hide();

    window.cookieconsent.initialise({
			content: cookie_content,
			type: "opt-out",
    });

    var w_height = $(window).height();
    var w_width = $(window).width();
    var $pageslider = $('.pageslider');
    var $specialcampaign = $('.special-campaign');
    var campaign_name = 'shampoo_campaign';

    // Variables for multistep form
    var current_fs, next_fs, previous_fs;
    var left, opacity, scale; //fieldset properties which we will animate

    if (w_width >= 768) {
        if ($('#CustomTrustbadge').length) {
            $('#CustomTrustbadge').appendTo("#trustBadgeDesktopContainer");
        }
    }


    // Init fullpage slider size
    resize($pageslider, w_width, w_height);

    // Resize fullpage slider on window resize
    $(window).on('resize', function () {
        var new_height = $(window).height();
        var new_width = $(window).width();

        resize($pageslider, new_width, new_height);

        // Updates trustbadge position on resize
        if (new_width >= 768) {
            if ($('#CustomTrustbadge').length) {
                $('#CustomTrustbadge').appendTo("#trustBadgeDesktopContainer");
            }
        }
        else {
            if ($('#CustomTrustbadge').length) {
                $('#CustomTrustbadge').appendTo("#trustBadgeMobileContainer");
            }
        }

    });

    setTimeout(function () {
        if (typeof $.cookie(campaign_name) === 'undefined') {
            var setcookie = $.cookie(campaign_name, 'shown');
            $specialcampaign.show();
        };
    }, 5000);

    $('.close-campaign').on('click', function (e) {
        var setcookie = $.cookie(campaign_name, 'shown');
        $specialcampaign.hide();
    });

    var $topMain = $('.top-main:not(.light-on)');

    // Check scrolltop for light on menu bar
    $(window).on('scroll', function () {
        $topMain.toggleClass("light-on", $(this).scrollTop() > 0);
    });

    // Scroll down frontpage
    var windowHeight = $(window).height();
    var percent = 0.1;
    var heightPercent = windowHeight * percent;
    $(document).on('click', 'button.scroll-down', function () {
        $('body, html').animate({ scrollTop: $('.first-section').offset().top - heightPercent }, 600);
    });

    // Hover on guarantee (product page)
    // var guaranteePopup = $('.guarantee-pop');

    // $('#guarantee').hover(function() {
    // 	guaranteePopup.fadeIn(200);
    // }, function() {
    // 	guaranteePopup.fadeOut(200);
    // });

    // Cart Trigger
    var $cartPopup = $('.cart-dropdown')
        .on('click.bs.dropdown', function (e) {
            e.stopPropagation();
        });

    // var $cartBackdrop = $('.cart-backdrop').click(function(event) {
    // 	$cartTrigger.trigger('click');
    // });

    // var $cartTrigger = $('#cart-trigger').on('click', function(event) {
    // 	event.preventDefault();
    // 	$cartPopup.fadeToggle(200);
    // 	// $cartBackdrop.toggleClass('hidden');
    // 	// $(document).click(function(event) {
    // 	// 	$cartTrigger.trigger('click');
    // 	// 	// $(document).unbind('click');
    // 	// })
    // })

    var $hamburger = $('.hamburger');
    var $productsMobileMenu = $('#products-mobile-menu');
    var $mobileCartTrigger = $('#mobile-cart-trigger, a.mobile-cart-menu');
    var $cartMobileMenu = $('#cart-mobile-menu');

    // Mobile menu functions
    function closeMenu() {
        close($hamburger, $productsMobileMenu);
    }

    function closeCart() {
        close($mobileCartTrigger, $cartMobileMenu);
    }

    // Hamburger trigger
    $hamburger.on('click', toggleMenu($productsMobileMenu, closeCart));

    // Mobile cart trigger
    $mobileCartTrigger.on('click', toggleMenu($cartMobileMenu, closeMenu));

    $('#close_menu').on('click', closeMenu);
    $('#close_cart, .close-cart').on('click', closeCart);

    // Checks carousel position field for smarter owl item order
    if($('#carousel_position').length && $('#carousel_position').val() == 1){
        $carousel_position = getRandomArbitrary(1, 8);
    }else{
        $carousel_position = 0;
    }

    // Frontpage and product sliders
    $('#top_slider, .product-carousel').owlCarousel({
        mouseDrag: false,
        items: 1,
        loop: false,
        margin: 0,
        nav: false,
        dots: true,
        video: true
    }).on("dragged.owl.carousel", function (event) {
        if(event.relatedTarget['_drag']['direction'] == 'left'){
            if($('#next-product').length){
                var href = $('#next-product').attr('href');
                window.location.href = href;
            }
        }else{
            if($('#previous-product').length){
                var href = $('#previous-product').attr('href');
                window.location.href = href;
            }
        }
        console.log('event : ',event.relatedTarget['_drag']['direction'])
    });

    // Frontpage and product sliders
    $('.minicart-product-carousel').owlCarousel({
        mouseDrag: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            },
            1200: {
                items: 1
            }
        },
        loop: true,
        margin: 0,
        nav: true,
        startPosition: $carousel_position,
        autoplay: true,
        autoplayHoverPause: true,
        dots: false,
        video: false,
        navText: ['<img class="prev" src="/assets/store/img/new/arrow-carousel-left.svg" />', '<img class="next" src="/assets/store/img/new/arrow-carousel-right.svg "/>'],
    });

    $("#thankyou-modal").on("shown.bs.modal", function () {
        if ($(".thankyou-modal").data('source-modal') == 1) {
            setTimeout(function () {
                $('#source-modal').modal('show');
                $("#thankyou-modal").addClass("behind-backdrop");
            }, 3000); // call "myfunc" after 3 seconds
        }
    });

    $("#source-modal").on("hidden.bs.modal", function () {
        $("#thankyou-modal").removeClass("behind-backdrop");
        $("#thankyou-modal").css('bottom','auto');
    });

    $('#resend-email').click(function (e) {
        e.preventDefault();
        //console.log(posturl);
        $.ajax({
            type: "GET",
            url: "/checkout/resend",
            cache: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data == 'ok') {
                    $(".error-message-resend").removeClass('error');
                    $(".error-message-resend").find("p").text('Το email επιβεβαίωσης εστάλη με επιτυχία!');
                    $(".error-message-resend").find("button").remove();
                }
                else {
                    $(".error-message-resend").find("p").text('Το email επιβεβαίωσης δεν εστάλη. Παρακαλούμε επικοινωνήστε μαζί μας!');
                    $(".error-message-resend").find("button").remove();
                }
            },
            error: function (error) {
            }
        });

    });

    // thank you modal
    $('.thankyou-modal').modal({
        backdrop: 'static',
        show: true,
        keyboard: false,
    });

    $('.toggle-cookies').on('click', function (e) {
        e.preventDefault();
        $('.cookies-wrapper').toggle();
    });

    $("#source-form").submit(function (e) {
        e.preventDefault(); // avoid to execute the actual submit of the form.
        var container = $('.error-container');
        container.text('');

        $.ajax({
            type: "POST",
            url: '/sources',
            data: $("#source-form").serialize(), // serializes the form's elements.
            success: function (data) {
                $('#source-modal').modal('hide');
            },
            error: function (data) {
                var errors = "";
                $.each(data.responseJSON, function (key, value) {
                    errors += "<div>" + value[0] + "</div>";
                });
                container.append("<div class='error margin-bottom'>" + errors + "</div>")
            }
        });
    });

    $("#unsubscribe-source-form").submit(function (e) {
        e.preventDefault(); // avoid to execute the actual submit of the form.
        var container = $('.error-container');
        container.text('');

        $.ajax({
            type: "POST",
            url: '/unsubscribeSources',
            data: $("#unsubscribe-source-form").serialize(), // serializes the form's elements.
            success: function (data) {
                $('#unsubscribe-panel').modal('hide');
            },
            error: function (data) {
                var errors = "Sie haben keins ausgewählt";
                $.each(data.responseJSON, function (key, value) {
                    errors += "<div>" + value[0] + "</div>";
                });
                container.append("<div class='error margin-bottom'>" + errors + "</div>")
            }
        });
    });

    $('.js-repeat-order').click(function (e) {
        $button = $(this);
        $('#repeat-order-modal').modal('show');
        $('#repeat_order_id').val($button.data('order'));
        $('.js-repeat-total').text($button.data('total'));

        if ($button.data('chargebale')) {
            var grand = parseFloat($button.data('shipping')) + parseFloat($button.data('total'));
            $('.js-repeat-shipping').text($button.data('shipping').toFixed(2));
            $('.js-repeat-grand-total').text(grand.toFixed(2));
            $('.js-shipping-row').removeClass('hidden');
            $('.js-shipping-free-row').addClass('hidden');
        }
        else {
            $('.js-shipping-row').addClass('hidden');
            $('.js-shipping-free-row').removeClass('hidden');
        }

        $('.js-repeat-total').text($button.data('total'));
    });

    // Testimonials and video gallery carousels
    $(".testimonials-carousel, .video-gallery").owlCarousel({
        loop: false,
        margin: 30,
        dots: true,
        autoplay: true,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            },
            1200: {
                items: 5
            }
        }
    });

    $(".extra-carousel").owlCarousel({
        mouseDrag: true,
        loop: true,
        margin: 0,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayHoverPause: true,
        video: false,
        stagePadding: 0,
        navText: ['<img class="prev" src="/assets/store/img/new/arrow-carousel-left.svg" />', '<img class="next" src="/assets/store/img/new/arrow-carousel-right.svg "/>'],
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            },
            1200: {
                items: 4
            },
            1400: {
                items: 5
            }
        }
    });

    // Remove the background placeholder and add vimeo iframe;
    // Get vimeo id from data attribute
    $('.video-item, .grid-video').click(function () {
        var id = $(this).find('.video-preview').data('vimeoid');
        $(this).html('<iframe src="https://player.vimeo.com/video/' + id + '?color=05ffc9&autoplay=1" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>');
    });

    // Number Spinner in cart
    $('.number-spinner').on('click', 'button', function (e) {
        e.preventDefault();
        var $btn = $(this),
            $item = $btn.closest('.cart-item'),
            $productDetails = $btn.closest('.details'),
            $spinner = $btn.closest('.number-spinner'),
            $input = $spinner.find('input'),
            min = $input.attr('min') || 1,
            max = $input.attr('max') || 1000,
            oldValue = parseInt($input.val().trim()),
            // Initialize the new value
            newValue = oldValue,
            // Get the type of spinner
            spinnerType = $spinner.data('spinner'),
            // Get single price from data attribute
            price = $spinner.data('price');

        if ($btn.attr('data-dir') == 'up' && oldValue < max) {
            newValue = oldValue + 1;
        };

        if ($btn.attr('data-dir') == 'down' && oldValue > min) {
            newValue = oldValue - 1;
        };

        $input.val(newValue);

        // check spinner type
        if (spinnerType == 'quantity') {
            // use to count products sum and counts
            var $subtotal = $spinner.closest('.row').find('.subtotal');

            subtotal($subtotal, newValue, price);
            total($item.closest('.cart'));

            if ($productDetails.length) {
                var items = $item.data('items') * newValue;
                $productDetails.find('.' + $spinner.data('type') + '-count').text(items);
            }
        }

        if (spinnerType == 'period') {
            // use to count next week shipping
            calcWeek($item, newValue, 'w');
        }
    });

    // Number Spinner in account
    $('.number-spinner-acc').on('click', 'button', function (e) {
        e.preventDefault();
        var $btn = $(this),
            $item = $btn.closest('.subscription-item'),
            $spinner = $btn.closest('.number-spinner-acc'),
            $input = $spinner.find('input'),
            min = $input.attr('min') || 1,
            max = $input.attr('max') || 9,
            oldValue = parseInt($input.val().trim()),
            // Initialize the new value
            newValue = oldValue,
            // Get the type of spinner
            spinnerType = $spinner.data('spinner'),
            // Get single price from data attribute
            price = $spinner.data('price');

        if ($btn.attr('data-dir') == 'up' && oldValue < max) {
            newValue = oldValue + 1;
        };

        if ($btn.attr('data-dir') == 'down' && oldValue > min) {
            newValue = oldValue - 1;
        };

        $input.val(newValue);
        $subtotal = newValue * price;
        $item.find('.subtotal').text($subtotal.toFixed(2));
        accountTotal($item.closest('.cart'));

    });

    // Enable flash modal
    $('#flash-overlay-modal').modal();

    // Enable checkout modal
    var $modalCheckout = $('.modal-checkout.display')
        .modal('show')
        // when the modal closes
        .on('hidden.bs.modal', function (e) {
            // hide the modal header which appears
            // when a product is added to cart
            $modalCheckout.find('.js-cart-added').hide();
            $modalCheckout.find('.js-cart-insufficient').hide();
        });

    $('[name="subscription"]').change(function () {
        var $this = $(this),
            price = parseFloat($this.data('price')).toFixed(2),
            diaper = parseFloat($this.data('diaper')).toFixed(2);

        $('.old-total-price').toggle();
        $('.price').text(price);
        $('.diaper-price').text(diaper);
    });

    $('.checkout-loader').click(function (event) {
        var $button = $(this);

        $button.text($button.data('loading'))
            .css({ 'pointer-events': 'none' })
            .prepend('<img src="/assets/store/img/ico-loader.svg">&nbsp;');
    });

    var $edps = $('#edps');

    if ($edps.length) {
        $edps.submit();
    }

    $("[type='number']").keypress(function (evt) {
        evt.preventDefault();
    });

    var firstChecked = $('.configurableProductContainer').find('input:checked');
    if (firstChecked) {
        var $image = $('.product-container').find('.img-baby-bodysuits');
        $image.attr('src', $(firstChecked).data('image'));
    };

    $('.bundleSumOptionSubContainer').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass('expanded');

        if($('#'+$(e.target).attr('for')).prop('checked') == false){

            var startPrice = 0, finalPrice = 0;

            startPrice = parseFloat($('#'+$(e.target).attr('for')).data('price'));

            mainDiaperPrice = parseFloat($('#'+$(e.target).attr('for')).data('maindiaperprice'));
            mainDiaperWeeks = parseFloat($('#'+$(e.target).attr('for')).data('weeks'));

            $(this).closest('.bundleSumOptionContainer').siblings('.bundleSumProducts').each(function (index, value) {
                startPrice += parseFloat(value.dataset.price);
            });

            finalPrice = startPrice + parseFloat($('.bundleSumDiscount').data('price'));

            $('.sumOfOptionsStartingPrice').each(function (index, elem) {
                var $elem = $(elem);
                $elem.text(startPrice.toFixed(2).replace(".", ","));
            });

            $('.sumOfOptionsFinalPrice').each(function (index, elem) {
                var $elem = $(elem);
                $elem.text(finalPrice.toFixed(2).replace(".", ","));
            });

            if(mainDiaperPrice != 0){
                $('.sample-bundle-main-diaper-price').html(mainDiaperPrice+'€');
                $('.sample-bundle-main-diaper-weeks').html(mainDiaperWeeks);
            }

            $('.bundleAssociatedDiaperName').html($('#'+$(e.target).attr('for')).data('name'));
            $('.bundleAssociatedDiaperQty').html($('#'+$(e.target).attr('for')).data('quantity'));
            $('.bundleAssociatedDiaperImg').attr("src",$('#'+$(e.target).attr('for')).data('image'));
        }

        $('#'+$(e.target).attr('for')).prop('checked',true);
      });

      // When click on last radio option of pack bundle modal form
      $('.dynamic-bundle-sub-btn').click(function(e) {
        // For each radio of the form find the checked ones and fill below div with proper info
        $('input:radio').each(function () {
            if($(this).is(':checked') && $(this).data('name') != undefined){
                $(".dynamicBundleName" + $(this).data('list')).html($(this).data('name'));
                $(".dynamicBundleImg" + $(this).data('list')).attr("src",$(this).data('image'));
                $(".dynamicBundleWeight" + $(this).data('list')).html($(this).data('weight'));
                $(".dynamicBundleQty" + $(this).data('list')).html($(this).data('qty'));
            }
        });

        // Place proper image to progress bar
        $(".progressPack" + $(this).data('list')).empty();
        if ($(window).width() >= 480) {
            $(".progressPack" + $(this).data('list')).prepend('<img src="'+$(this).data('image')+'" style="width:30px;height:45px;position:absolute;top:-12px;left:51px;z-index:1;" />');
        }else{
            $(".progressPack" + $(this).data('list')).prepend('<img src="'+$(this).data('image')+'" style="width:30px;height:45px;position:absolute;top:-12px;left:22px;z-index:1;" />');
        }

        // Show add to cart button
        if ($(window).width() >= 768) {
            $('.dynamic-bundle-to-cart-desktop').attr('style','display: inline-block !important');
        }else{
            $('.dynamic-bundle-to-cart-mobile').attr('style','display: inline-block !important');
        }
        // Hide description text in mobile and show modal opener link
        $('.dynamic-bundle-description-text').attr('style','display: none !important');
        $('.dynamic-bundle-anchor-link').show();
        // Hide modal opener button and show below div with info
        $('.pack-modal-button').hide();
        $('.packs-container').show();
        // Hide default image and show custom image container
        if($('.pack-modal-empty-img').is(":visible")){
            var dynamicBundleImageWidth = $('.dynamic-bundle-image-default').width();
            if ($(window).width() >= 1440) {
                dynamicBundleImageWidth = 380;
            }else if($(window).width() >= 1280){
                dynamicBundleImageWidth = 280;
            }else if($(window).width() >= 992){
                dynamicBundleImageWidth = 260;
            }else if($(window).width() >= 768){
                dynamicBundleImageWidth = 400;
            }else if($(window).width() >= 480){
                dynamicBundleImageWidth = 330;
            }else{
                dynamicBundleImageWidth = 215;
            }
            $('.pack-modal-empty-img').hide();
            $('.pack-modal-filled-img').show();
            $('.dynamic-bundle-image').height(dynamicBundleImageWidth);
        }
      });

    $('.toggleFooter').on('click', function (e) {
        e.preventDefault();
        $('.footer-product').toggleClass('hidden');
        return false;
    });

    //$('.configurable-selection.select-baby-bodysuits-options').first().css("display", "flex");

    /*  $('.configurableProductContainer').each(function(elem) {



        })
    */

    $('.configurableType').on('click', function (e) {
        var $that = $(this).parent().parent().parent().parent();
        console.log($that);
        var type = (e.target.dataset.sleeve);
        $that.find('.configurable-selection.select-baby-bodysuits-options').css("display", "none");
        $that.find('.configurable-options-container').find('div.' + type).css("display", "flex");

        var $image = $('.product-container').find('.img-baby-bodysuits');
        $image.attr('src', $(e.target).data('image'));

    });

    $('.loader-spinner').on('click', function (e) {
        $('#loading').show();
    });

    $('.vibration').on('click', function (e) {
        $(this).animate({ opacity: "0.5" }, 150);
        $(this).animate({ opacity: "1" }, 150);
    });

    $('.ingredients-down-arrow').on('click', function (e) {
        if ( $( this ).hasClass( "toggle-down" ) ) {
            $( this ).removeClass( "toggle-down" );
            $( this ).addClass( "toggle-up" );
            $('.ingredients-text').slideUp("slow");
        }else{
            $( this ).removeClass( "toggle-up" );
            $( this ).addClass( "toggle-down" );
            $('.ingredients-text').slideDown("slow");
        }
    });

    $('.faq-question').on('click', function (e) {
        $('.faq-answer').addClass( "hidden" );
        $(this).siblings('.faq-answer').toggleClass('hidden');
    });

    $('.address-fields').click(function (event) {
        var street = $('#street').val();
        var city = $('#city').val();
        var postal_code = $('#postal_code').val();
        var phone = $('#phone').val();

        $('#cart_street').val(street);
        $('#cart_city').val(city);
        $('#cart_postal_code').val(postal_code);
        $('#cart_phone').val(phone);
    });

    $('.address-remove').click(function (event) {

        var street = $('#street').val();
        var city = $('#city').val();
        var postal_code = $('#postal_code').val();
        var phone = $('#phone').val();

        $('#cart_remove_street').val(street);
        $('#cart_remove_city').val(city);
        $('#cart_remove_postal_code').val(postal_code);
        $('#cart_remove_phone').val(phone);

    });

    $(".tabs-account a").click(function (event) {
        event.preventDefault();
        $(this).parent().addClass("current");
        $(this).parent().siblings().removeClass("current");
        var tab = $(this).attr("href");
        $(".tab-account-content").not(tab).css("display", "none");
        $(tab).fadeIn(200, function () {

        });
    });

    $(".tabs-cookies a").click(function (event) {
        event.preventDefault();
        $(this).parent().addClass("current");
        $(this).parent().siblings().removeClass("current");
        var tab = $(this).attr("href");
        $(".tab-cookie-content").not(tab).css("display", "none");
        $(tab).fadeIn(200, function () {

        });
    });

    $(".tabs-login a").click(function (event) {
        event.preventDefault();
        $(this).parent().addClass("current");
        $(this).parent().siblings().removeClass("current");
        var tab = $(this).attr("href");
        $(".tab-login-content").not(tab).css("display", "none");
        $(tab).fadeIn(200, function () {

        });
    });

    if(window.location.href.indexOf("register-section") > -1 && w_width < 768) {
        $(".register-tab").addClass("current");
        $(".login-tab").removeClass("current");
        var tab = $(".register-tab a").attr("href");
        $(".tab-login-content").not(tab).css("display", "none");
        $(tab).fadeIn(200, function () {

        });
     }

    $("#closeTC").click(function (event) {
        $(this).parent().css({
            'display' : 'none'
        });
    });

    $(function () {
        $("#datepicker").datepicker("option", "dateFormat", 'd MM, y');
    });

    $('.datepicker').datepicker({
        format: 'dd/mm/yyyy',
        language: 'el',
    });

    var $modal = $('#add-extra-product');
    $modal.on('shown.bs.modal', function (e) {
        var action = $(e.relatedTarget).data('action');
        var item = $(e.relatedTarget);
        var product = item.data('product');

        $modal.find('.name').html(product.name);
        $modal.find('.price').html(product.price);
        $modal.find('.product_id').val(product.id);
        $modal.find('form').attr('action', action);
    });

    if ($.cookie('cookieconsent_status') != 'dismiss') {
        // $('.cookies-wrapper').show();
    };
    console.log($.cookie('cookieconsent_status'));
});

// FUNCTIONS

// ON DRAG OF DIAPER PRODUCT
// $('.diaper-carousel').on('initialized.owl.carousel', function(e) {
//     var last = e.item.index, skip = false;
//     $(this).on({
//         'translated.owl.carousel': function(e) {
//         alert($('.owl-stage').css('transform'));
//         alert('yata');
//         },
//         'cycle.owl.autoplay': function() {
//         skip = true;
//         }
//     });
// });

function resize($element, width, height) {
    $element.css({
        height: height,
        width: width
    });
}

function toggleMenu($menu, callback) {
    return function (e) {
        var $this = $(this);
        e.preventDefault();

        if ($this.hasClass('active')) {
            $this.removeClass('active');
            $menu.removeClass('open');
        } else {
            callback();
            $this.addClass('active');
            $menu.addClass('open');
        }
        document.body.style.overflow = 'hidden';
    };
}

// Calc single product price
function subtotal($el, quantity, price) {
    var subtotal = quantity * price;
    $el.text(subtotal.toFixed(2));	// Print the product price
}

// Calc final sum and products count in cart
function total($cart) {
    var total = 0;

    var items = {};
    var packs = {};

    $cart.find('.cart-item').each(function () {
        var $item = $(this);
        var row_items = $item.data('items');
        var row_packs = $item.data('packs');

        var quantity = $item.find('.product-quantity input').val();

        for (var type in row_items) {
            if (!(type in packs)) {
                packs[type] = 0;
                items[type] = 0;
            };

            packs[type] += quantity * row_packs[type];
            items[type] += quantity * row_items[type];
        };

        // subtotal
        total += $item.data('price') * quantity;
    });

    for (var type in items) {
        $cart.find('.js-' + type + '-packs').text(packs[type]);
        $cart.find('.js-' + type + '-items').text(items[type]);
    };

    $cart.find('.js-checkout-total').text(total.toFixed(2));	// Print the final price

    var payment_fee = $cart.find('.js-checkout-payment-fee').data('fee');

    $cart.find('.js-checkout-payment-fee-text').text(payment_fee.toFixed(2));	// Print the payment fee

    if (payment_fee > 0) {
        $cart.find('.js-checkout-payment-fee').removeClass('hidden');
    } else {
        $cart.find('.js-checkout-payment-fee').addClass('hidden');
    }
    console.log($cart.find('.js-checkout-payment-fee'));

    var shipping_threshold = $cart.find('.js-checkout-shipment-fee').data('threshold');

    console.log(packs['diapers'], total, shipping_threshold, payment_fee);

    // Shipping if doesnt have diapers and total less than 15 €
    if (total < shipping_threshold) {
        var shipment_fee = $cart.find('.js-checkout-shipment-fee').data('fee');
        $cart.find('.js-checkout-shipment-fee-text').text(shipment_fee.toFixed(2));	// Print the shipment fee
        $cart.find('.js-checkout-grand-total').text((total + payment_fee + shipment_fee).toFixed(2));	// Print the final price
        $cart.find('.js-shipment-difference').text((shipping_threshold - total).toFixed(2));	// Print the free shipping difference
        $cart.find('.js-checkout-total-container').removeClass('hidden');	// Show shipping fields
        $cart.find('.js-checkout-shipment-fee-container').removeClass('hidden');	// Show shipping fields
        $cart.find('.js-shipment-free').addClass('hidden');	// Change shipping free above checkout button
        $cart.find('.js-shipping-fee').removeClass('hidden');	// Change shipping free above checkout button
        $cart.find('.shipment-difference-box').removeClass('hidden');	// Change shipping free above checkout button
        $cart.find('.shipment-fee-box').addClass('hidden');	// Change shipping free above checkout button
    } else {
        $cart.find('.js-checkout-total-container').addClass('hidden');	// Hide shipping fields
        $cart.find('.js-checkout-shipment-fee-container').addClass('hidden');	// Hide shipping fields
        $cart.find('.js-checkout-grand-total').text(total.toFixed(2));	// Print the final price
        $cart.find('.js-shipping-fee').addClass('hidden');	// Change shipping free above checkout button
        $cart.find('.js-shipment-free').removeClass('hidden');	// Change shipping free above checkout button
        $cart.find('.shipment-difference-box').addClass('hidden');	// Change shipping free above checkout button
        $cart.find('.shipment-fee-box').removeClass('hidden');	// Change shipping free above checkout button
    };

}

// Calc final sum and products count in account
function accountTotal($cart) {
    var total = 0;

    $cart.find('.subscription-item').each(function () {
        var $item = $(this);

        $price = $item.find('.number-spinner-acc').data('price');

        var quantity = $item.find('.number-spinner-acc input').val();

        total += $price * quantity;
    });

    $cart.find('.grand-total').text(total.toFixed(2));
}

// Calc next shipping in weeks
function calcWeek($item, number, type) {
    var date = moment();
    var nextShipment = date.add(number, type);
    $item.find('.next-shipping').html(nextShipment.format('DD.MM.YY'));
}

function close($trigger, $menu) {
    $trigger.removeClass('active');
    $menu.removeClass('open');
    document.body.style.overflow = 'visible';
}

//Random number between min and max
function getRandomArbitrary(min, max) {
    return Math.floor(Math.random() * max) + min;
}

$(document).mouseup(function(e)
{
    if ($('#customCheckoutDiv').length) {
        var trustCardContainer = $("#customCheckoutDiv");

        // if the target of the click isn't the container nor a descendant of the container
        if (!trustCardContainer.is(e.target) && trustCardContainer.has(e.target).length === 0 && $('#source-modal').is(":hidden"))
        {
            trustCardContainer.hide();
        }
    }
});

$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

$(document).click(function() {
    $('.dropdown-el').removeClass('expanded');
});

// When click on first and second radio option of pack bundle modal form in order to move to next form radios
$(".dynamicBundleOption").click(function(){

    current_fs = $(this).parent().parent().parent();
    next_fs = $(this).parent().parent().parent().next();

    //activate next step on progressbar using the index of next_fs
    $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

    //show the next fieldset
    next_fs.show();
    //hide the current fieldset with style
    current_fs.animate({opacity: 0}, {
        step: function(now, mx) {
            //as the opacity of current_fs reduces to 0 - stored in "now"
            //1. scale current_fs down to 80%
            scale = 1 - (1 - now) * 0.2;
            //2. bring next_fs from the right(50%)
            left = (now * 50)+"%";
            //3. increase opacity of next_fs to 1 as it moves in
            opacity = 1 - now;
            current_fs.css({
        'transform': 'scale('+scale+')',
        'position': 'absolute'
      });
            next_fs.css({'left': left, 'opacity': opacity});
        },
        duration: 800,
        complete: function(){
            current_fs.hide();
        }
    });
    // Place proper image to progress bar
    $(".progressPack" + $(this).data('list')).empty();
    if ($(window).width() >= 480) {
        $(".progressPack" + $(this).data('list')).prepend('<img src="'+$(this).data('image')+'" style="width:30px;height:45px;position:absolute;top:-12px;left:51px;z-index:1;" />');
    }else{
        $(".progressPack" + $(this).data('list')).prepend('<img src="'+$(this).data('image')+'" style="width:30px;height:45px;position:absolute;top:-12px;left:22px;z-index:1;" />');
    }
});

// When click on previous button of pack bundle modal form in order to move to previous form radios
$(".previous-step").click(function(){

    current_fs = $(this).parent();
    previous_fs = $(this).parent().prev();

    //de-activate current step on progressbar
    $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

    //show the previous fieldset
    previous_fs.show();
    //hide the current fieldset with style
    current_fs.animate({opacity: 0}, {
        step: function(now, mx) {
            //as the opacity of current_fs reduces to 0 - stored in "now"
            //1. scale previous_fs from 80% to 100%
            scale = 0.8 + (1 - now) * 0.2;
            //2. take current_fs to the right(50%) - from 0%
            left = ((1-now) * 50)+"%";
            //3. increase opacity of previous_fs to 1 as it moves in
            opacity = 1 - now;
            current_fs.css({'left': left});
            previous_fs.css({'transform': 'scale('+scale+')', 'opacity': opacity});
        },
        duration: 800,
        complete: function(){
            current_fs.hide();
        }
    });
    // Uncheck radio button of current step and remove image from progress bar
    $(this).siblings('div').children('.dynamicBundleSumOptionSubContainer').children('input[type=radio]:checked').prop("checked", false);
    $(".progressPack" + $(this).data('list')).empty();
});

// Smooth hide of pack bundle modal form
$(".dynamic-bundle-sub-btn").click(function(e){
    $('#select-pack').modal('hide').scrollTop();
});